import React from 'react'

const NoFound = () => {
    return (
        <div className='text-center py-2 bg-pink-100 mt-6 rounded-sm font-semibold text-black'>
            <h6>No Data Found</h6>
        </div>
    )
}

export default NoFound
